import "bootstrap";
import "slick-carousel";

window._ = require("lodash");

try {
  window.Popper = require("popper.js").default;
  window.$ = window.jQuery = require("jquery");
} catch (e) {}

jQuery(function () {
  setTopo();
  // logoPaginas()
  $(window).scroll(function () {
    setTopo();
    // logoPaginas()
  });
  $(window).on("resize", function () {});

  $(".slider").slick({
    dots: true,
    infinite: false,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
  });

  $(".slider-6").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

  $("#menu_home_principal a").on("click", function () {
    jQuery(".animated-icon2").removeClass("open");
    jQuery(".menu").removeClass("open");
    setTimeout(function () {
      $(".menu").removeClass("openMenu");
      $(".navbar-toggler").removeClass("open");
      jQuery("header").removeClass("open");
    }, 500);
    $(".itens-menu").hide();
  });

  jQuery(".second-button").on("click", function () {
    if ($(".menu").hasClass("openMenu") && $(".menu").hasClass("open")) {
      jQuery(".animated-icon2").removeClass("open");
      jQuery(".menu").removeClass("open");
      setTimeout(function () {
        $(".menu").removeClass("openMenu");
        $(".navbar-toggler").removeClass("open");
        jQuery("header").removeClass("open");
      }, 500);
      $(".itens-menu").hide();
    } else {
      if (!$(".menu").hasClass("openMenu")) {
        jQuery("header").addClass("open");
        jQuery(".menu").addClass("open");
        jQuery(".animated-icon2").addClass("open");
        $(".menu").addClass("openMenu");
        $(".navbar-toggler").addClass("open");
        setTimeout(function () {
          $(".itens-menu").stop(true, true).fadeIn(200);
        }, 1000);
      }
    }
    return false;
  });

  function setTopo() {
    var rolagem = $(window).scrollTop();
    if (rolagem > 150) {
      $("header").addClass("fixo");
    } else {
      $("header").removeClass("fixo");
    }
  }

  $(".abrirModal").click(function () {
    var arquivo = $(this).attr("data-artigo");
    $("#wpcf7-f33-o1").attr("data-artigo", arquivo);
    $(".form-arquivo-download").val(arquivo);
    $("#modal").fadeIn();
    return false;
  });

  $("#fecharModal").click(function () {
    $("#modal").fadeOut();
    return false;
  });

  document.addEventListener("wpcf7mailsent", function (event) {
    if (event.detail.contactFormId === 33) {
      var arquivo = $("#wpcf7-f33-o1").attr("data-artigo");
      window.open(arquivo, "_blank");
    }
  });

  setInterval(function () {
    if ($(".seta").hasClass("setaAtiva")) {
      $(".seta").removeClass("setaAtiva");
    } else {
      $(".seta").addClass("setaAtiva");
    }
  }, 500);

  function logoPaginas() {
    var body = $("body");
    var scroli = $(window).scrollTop();
    //
    var areaHome = $(".area-home").height();
    var areaRoxa = areaHome + $("#sobre-roxo").height() + 200;
    var areaPorc = areaRoxa + $(".blocoPorcentagem").height() + 400;
    var areaAnos = areaPorc + $(".anos").height();
    var Total = $(".lista-portfolio").length;
    var areaHome2 = areaHome + $(".lista-portfolio").eq(0).height() * Total;

    if ($("#navbar-example2").hasClass("openMenu")) {
      $(".logo-branca").show();
      $(".logo-preta").hide();
    } else {
      if (body.hasClass("page-template-tpl-sobre")) {
        if (scroli > areaAnos) {
          $(".logo-branca").hide();
          $(".logo-preta").show();
        } else if (scroli > areaPorc) {
          $(".logo-branca").show();
          $(".logo-preta").hide();
        } else if (scroli > areaRoxa) {
          $(".logo-branca").hide();
          $(".logo-preta").show();
        } else if (scroli > areaHome) {
          $(".logo-branca").show();
          $(".logo-preta").hide();
        } else {
          $(".logo-branca").hide();
          $(".logo-preta").show();
        }
      } else if (body.hasClass("page-template-tpl-home")) {
        if (scroli > areaHome2) {
          $(".logo-branca").hide();
          $(".logo-preta").show();
        } else {
          $(".logo-branca").show();
          $(".logo-preta").hide();
        }
      } else if (
        body.hasClass("page-template-tpl-servicos") ||
        body.hasClass("blog") ||
        body.hasClass("post-type-archive-cases")
      ) {
        $(".logo-branca").hide();
        $(".logo-preta").show();
      }
    }
  }

  $("#btn-modal").on("click", function () {
    $("#modal-form").fadeIn();
  });

  $(".modal-formulario-close").on("click", function () {
    $("#modal-form").fadeOut();
  });
});
